import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

export const COMPONENT_COLUMN_TOOLTIP =
  'The product modules each issue affects. Issues that affect only modules no device in your fleet runs are marked Config removed automatically.';

/**
 * The Component column header.
 *
 * `id` must be unique per mounted table — the bug and CVE tables are separate
 * mounts and reactstrap resolves tooltip targets by DOM id.
 */
export const ComponentColumnHeader = ({ id }) => (
  <th className="bst-component-col">
    Component
    <span id={id} className="bst-component-info" tabIndex={0} aria-label="What the Component column shows">
      <FontAwesomeIcon icon={faInfoCircle} />
    </span>
    <UncontrolledTooltip target={id} placement="top">
      {COMPONENT_COLUMN_TOOLTIP}
    </UncontrolledTooltip>
  </th>
);

/**
 * One Component cell.
 *
 * The names are never struck through on an auto-marked row even though the ID
 * and summary are: this column is the reason the row was struck, and striking
 * the reason out with the row hides the one thing a reviewer checks when they
 * think the automation got it wrong.
 */
const ComponentCell = ({ data, tooltipId }) => {
  if (!data) {
    return (
      <td className="bst-component-cell">
        <span className="text-muted">—</span>
      </td>
    );
  }

  return (
    <td className="bst-component-cell">
      <span>
        {data.inline.join(', ')}
        {data.overflow > 0 && (
          <>
            {' '}
            <span id={tooltipId} className="bst-component-more" tabIndex={0}>
              +{data.overflow}
            </span>
            <UncontrolledTooltip target={tooltipId} placement="top">
              {data.allLabel}
            </UncontrolledTooltip>
          </>
        )}
      </span>
      {data.note && <div className="bst-component-note">{data.note}</div>}
    </td>
  );
};

export default ComponentCell;
